import type { NewsTranslations } from "../interfaces/news";

export const newsTranslations: NewsTranslations = {
  page_title: "Notícias e avisos",
  page_subtitle: "Consulte as notas ativas e pesquise por título ou descrição.",
  search_placeholder: "Buscar notas por título, descrição",
  search_aria: "Buscar",
  new_note_button: "Nova nota",

  error_load: "Erro ao carregar as notas.",
  error_create: "Erro ao criar a nota.",
  error_delete: "Erro ao excluir a nota.",

  loading_notes: "Carregando notas…",
  searching: "Buscando…",
  empty_search: "Nenhuma nota corresponde à pesquisa.",
  empty_no_notes: "Não há notas ativas para exibir.",
  load_more_aria: "Mostrar mais notas",
  load_more_loading: "Carregando…",
  load_more: "Mostrar mais",

  card_pinned_aria: "Fixada",
  card_delete_aria: "Excluir nota",
  card_attachments_aria: "Anexos",
  card_attachments_section_title: "Anexos",
  card_attachments_count: "{{count}} arquivo(s)",
  card_attachment_download_title: "Baixar arquivo {{n}}",
  card_attachment_download_aria: "Baixar arquivo {{n}}",
  card_attachment_download_error: "Erro ao baixar o arquivo.",

  category_WORK_PERMIT: "Permissão de trabalho",
  category_SCHEDULED_MAINTENANCE: "Manutenção programada",
  category_INCIDENT: "Incidente",
  category_GENERAL: "Geral",
  category_REMINDER: "Lembrete",
  category_URGENT_NOTICE: "Aviso urgente",
  category_PROCESS_CHANGE: "Mudança de processo",
  category_CLIENT_ISSUE: "Problema com cliente",
  category_TRAINING: "Treinamento",
  category_MEETING: "Reunião",

  priority_LOW: "Baixa",
  priority_MEDIUM: "Média",
  priority_HIGH: "Alta",
  priority_URGENT: "Urgente",

  modal_new_title: "Nova nota",
  modal_close_aria: "Fechar",
  modal_label_title: "Título",
  modal_title_placeholder: "Título da nota",
  modal_label_content: "Conteúdo",
  modal_content_placeholder: "Conteúdo da nota",
  modal_label_category: "Categoria",
  modal_category_placeholder: "Selecionar categoria",
  modal_label_priority: "Prioridade",
  modal_priority_placeholder: "Selecionar prioridade",
  modal_pin_label: "Fixar nota",
  modal_pin_aria: "Fixar nota",
  modal_label_attachments: "Anexos (opcional)",
  modal_attachments_description: "PNG, JPG, WebP ou PDF até 10 MB. Você pode escolher vários arquivos.",
  modal_attachments_instruction: "Clique para selecionar ou arraste arquivos aqui",
  modal_cancel: "Cancelar",
  modal_creating: "Criando…",
  modal_create_button: "Criar nota",

  validation_title_required: "O título é obrigatório.",
  validation_title_length: "O título deve ter entre {{min}} e {{max}} caracteres.",
  validation_content_required: "O conteúdo é obrigatório.",
  validation_category_required: "A categoria é obrigatória.",
  validation_priority_required: "A prioridade é obrigatória.",

  delete_modal_title: "Excluir nota",
  delete_modal_cancel: "Cancelar",
  delete_modal_confirm: "Excluir",
  delete_modal_warning: "Esta ação não pode ser desfeita.",
  delete_modal_message_with_title:
    "Tem certeza de que deseja excluir a nota «{{title}}»? Esta ação não pode ser desfeita.",
  delete_modal_message_no_title:
    "Tem certeza de que deseja excluir esta nota? Esta ação não pode ser desfeita.",
};
